import PracticeInformationIcon from '../../../../../../assets/icons/PracticeInfoIconClean_Small300px.png';
import PersonalityIconPurple from '../../../../../../assets/icons/PersonalityIconPurpleV2.png';
import ExpertiseIconClean from '../../../../../../assets/icons/ExpertiseIconClean4LightBlueV2.png';
import IdentitiesIcon from '../../../../../../assets/icons/IdentitiesIconV2.png';
import GoLiveIconClean from '../../../../../../assets/icons/GoLiveIconClean3V3.png';

export type contentDataType = {
  img: string;
  title: string;
  description: string;
  time: string;
  isLineImage: boolean;
};

export const contentData = [
  {
    img: PracticeInformationIcon,
    title: 'Practice Information',
    description:
      'The basics about you and your practice - including your professional bio, headshot, credentials, and an optional photo of your office space',
    time: '5 mins',
    isLineImage: true,
  },
  {
    img: ExpertiseIconClean,
    title: 'Expertise',
    description:
      'Select the specific issues you treat, your top areas of clinical expertise, and your preferred therapeutic modalities',
    time: '2 mins',
    isLineImage: true,
  },
  {
    img: IdentitiesIcon,
    title: 'Identity',
    description:
      'Share how you identify to help us thoughtfully match you with clients. You completely control whether this is visible to clients searching for specific identities, or used strictly behind the scenes for our matching algorithm',
    time: '2 mins',
    isLineImage: true,
  },
  {
    img: PersonalityIconPurple,
    title: 'Personality',
    description:
      'Take a quick, engaging personality quiz to optimize your matches with clients whose communication styles naturally align with yours',
    time: '3 mins',
    isLineImage: true,
  },
  {
    img: GoLiveIconClean,
    title: 'Go Live',
    description:
      "Review i2i’s billing structure, securely add your credit card, and submit your profile for our quick credential review. Once approved, you'll be able to easily add your availability from your dashboard and start receiving matches",
    time: '3 mins',
    isLineImage: false,
  },
];
